// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__5weW5","socials":"Footer_socials__KV59Z","logoo":"Footer_logoo__FwA7Z"};